import { FC } from 'react';

import classNames from 'classnames';
import ReactPaginate, { ReactPaginateProps } from 'react-paginate';

import './Paginate.scss';

import { TestMetadata } from '../types';

export type PaginateProps = Partial<ReactPaginateProps> &
  Pick<ReactPaginateProps, 'pageCount'> & {
    // Test IDs for component sections
    testMetadata?: {
      paginate?: TestMetadata;
      previousLabel?: TestMetadata;
      nextLabel?: TestMetadata;
    };
    style?: 'numbers' | 'dots';
    hideNavButtons?: boolean;
  };

const Paginate: FC<PaginateProps> = (paginateProps) => {
  return paginateProps.pageCount > 1 ? (
    <div
      className={classNames('sb-paginate', {
        'sb-paginate__dots': paginateProps?.style === 'dots',
      })}
    >
      <ReactPaginate
        previousLabel={
          !paginateProps.hideNavButtons && (
            <div {...paginateProps.testMetadata?.previousLabel}>
              <i className="fas fa-chevron-left" />
            </div>
          )
        }
        nextLabel={
          !paginateProps.hideNavButtons && (
            <div {...paginateProps.testMetadata?.nextLabel}>
              <i className="fas fa-chevron-right" />
            </div>
          )
        }
        containerClassName="sb-paginate__container"
        pageClassName="sb-paginate__page"
        pageLinkClassName="sb-paginate__page-link"
        previousClassName="sb-paginate__previous"
        previousLinkClassName="sb-paginate__previous-link"
        nextClassName="sb-paginate__next"
        nextLinkClassName="sb-paginate__next-link"
        breakClassName="sb-paginate__break"
        breakLinkClassName="sb-paginate__break-link"
        activeClassName="sb-paginate__active"
        activeLinkClassName="sb-paginate__active-link"
        disabledClassName="sb-paginate__disabled"
        {...paginateProps.testMetadata?.paginate}
        marginPagesDisplayed={1}
        pageRangeDisplayed={5}
        {...paginateProps}
      />
    </div>
  ) : null;
};

export default Paginate;
